import { Controller } from '@hotwired/stimulus';

export default class InputValidationController extends Controller {
  static readonly targets = ['input', 'errorMessageContainer', 'errorMessage'];
  static readonly values = {
    message: String,
  };
  static readonly classes = ['hidden'];

  declare inputTargets: HTMLInputElement[];
  declare errorMessageContainerTarget: HTMLElement;
  declare errorMessageTarget: HTMLElement;
  declare hasErrorMessageTarget: boolean;
  declare messageValue: string;
  declare hasMessageValue: boolean;
  declare hiddenClass: string;

  static isInvalid(input: HTMLInputElement) {
    return input.getAttribute('aria-invalid') === 'true';
  }

  static updateValidationMessage(input: HTMLInputElement) {
    input.setCustomValidity(input.validationMessage);
  }

  initialize() {
    this.inputTargets.forEach((input) =>
      input.addEventListener('input', () => this.onInput(input)),
    );

    if (this.hasErrorMessageTarget && this.messageValue) {
      this.inputTargets.forEach((input) => {
        if (InputValidationController.isInvalid(input)) {
          input.setCustomValidity(this.messageValue);
          InputValidationController.updateValidationMessage(input);
        }
      });
    }
  }

  onInput = (input: HTMLInputElement) => {
    // Clear custom validation on first change and allow native to take over
    input.setCustomValidity('');
    InputValidationController.updateValidationMessage(input);

    if (InputValidationController.isInvalid(input)) {
      this.errorMessageTarget.textContent = '';
      this.errorMessageContainerTarget.classList.add(this.hiddenClass);
      input.setAttribute('aria-invalid', 'false');
    }
  };
}
